import React from 'react'
import { useSiteMetadata } from 'src/hooks/useSiteMetadata'
import Modal from 'src/components/UI/Modal/Modal'
import MainNav from 'src/containers/TopStripe/MainNav/MainNav'
import menuModalClasses from './MenuModal.module.scss'


const MenuModal = ({ location }) => {
    const { menuLinks } = useSiteMetadata()
    return (
        <Modal
            name='menu'
            className="menu-popup"
            showDoneButton={false} >
            <div className={menuModalClasses.menuModalWrapper}>
                <MainNav menuLinks={menuLinks} location={location} onModal={true} />
            </div>
        </Modal>
    )
}

export default MenuModal
